import {Component, OnInit, Pipe, Inject} from '@angular/core';

import {FoEventsService} from "../event/foevents.service";
import {WeekPipe} from "./week.pipe";
import {DateFPipe} from "./date.pipe";
import {Router} from "@angular/router";
import {FonctionUtiles} from "../fonctionsUtiles";
import {BooKingservice} from "../booking/booking.service";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
  providers :[ FoEventsService],
})

export class HomeComponent implements OnInit {
  events :Event[][];
  sliders = [];
  slidersArray = [];
  discoverArray = [];
  discovers = [];
  pipe = new WeekPipe();
  selected:any;
  event:any;
  all:any;
  ticketingsType:any = [];
  hometrans:any;
  constructor (private bookingservice: BooKingservice,private eventservice :FoEventsService, private router:Router, public functionUtils: FonctionUtiles ) {}

  ngOnInit () {
    this.bookingservice.store('embeded',false);
    this.bookingservice.removeItem('codePromosActivated');
    this.initEventTicketingType();
     let days = ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'];
     let months = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet','Aout','Septembre','Octobre','Novembre','Decembre'];
      //  this.dayname = days[d.getDay()];
      // this.hours =d.getHours();
      // this.day=d.getDate();
      //  this.geocoder=new google.maps.Geocoder();
      //  this.month=months[d.getMonth()];
     this.Monthevents();
     this.getDiscoSliderEvent();

  }

  buildMetaDesc(event): string {
    return event.name + ' - ' + event.location_name +
      ' ' + this.hometrans.book_on_akces_your_market_place
  }

  filterMonth(events) {
    let c = new Date();
    let month:any = [];
    for(let i = 0; i < events.length; i++) {
      let closed = (events[i].end_date + ' ' + events[i].end_hour)
      let dClosed = new Date(closed.replace(/ /g,"T"));
      if(dClosed.getTime() - c.getTime()  <= 0) {
        month.push(events[i])
      }
    }

    return  month;
  }

  formatEvents(res) {
    for (let i = 0 ; i < res.length; i++) {
      res[i].has_ticketing = parseInt(res[i].has_ticketing);
    }
    return res;
  }

  Monthevents(): Promise<any[][]> {
    let c = new Date();
     this.eventservice.monthevent(c.getTime()).then(any => {
       this.events = this.formatEvents(any);
       this.all = this.formatEvents(any);
       this.selected = 'mois'
     });
    return ;
  }

  applySolidarityFlag(event) {
    return parseInt(event.has_open_ticketing);
  }

  getRightSolidarytyFlagByLang() {
    if(this.functionUtils.retrieve('curentLang') == 'fr') {
      return 'assets/imgs/frenchbadge.jpeg'
    } else {
      return 'assets/imgs/englishbadge.jpeg'
    }
  }

  getDiscoSliderEvent(): Promise<any> {
    let c = new Date();
    return this.eventservice.discoSliderEvent(c.getTime()).then(any => {
      this.discovers = this.formatEvents(any.discover);
      this.sliders = this.formatEvents(any.slider);
      let index = 0, r = [];
      for(let i in this.discovers){
        index++;
        r.push(this.discovers[i]);
        if(index == 2){
          this.discoverArray.push(r);
          r = [];
          index = 0;
        }
      }
      if(index > 0)
        this.discoverArray.push(r);
    });
  }
  getWeeksevents(): Promise<any> {
    let c = new Date();
    return this.eventservice.monthevent(c.getTime()).then(any => {
       this.events = this.pipe.transform(this.formatEvents(any))
       this.all = this.formatEvents(any);
       this.selected = 'semaine'
      });
  }



  // TODO #MEDIUM code repeated in event detail ts
  slugify(string) {
    return string
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[éèêë]/g,"e")
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
  }

  getTicketingType(event) {
        if(event.has_ticketing)
          return this.ticketingsType[0];

        else if(event.has_registration_module)
          return this.ticketingsType[1];

        else if(event.has_open_ticketing)
          return this.ticketingsType[3];
        else
          return this.ticketingsType[2];
  }

    initEventTicketingType () {
     this.ticketingsType = [
       {
        title: 'home.buy',
        label: 'home.buy',
        class:''
       },
       {
        title: 'S\'inscrire',
        label: 'S\'inscrire',
        class:''

       },
       {
        title: 'home.see',
        label: 'home.see',
        class:' btn-grey'
       },
       {
         title: 'home.participate',
         label: 'home.participate',
         class:''
       }
  ]

}

isPro() {
    return environment.pro === true;
}


eventIsOnline(event) {
   return event.onlineLocationChoice === 'evenemet_en_ligne';
}

eventNotHaveLocation(event) {
   return event.onlineLocationChoice === 'a_venir';
}

}
